
<template>
  <div id="statistik">
      <PublicMenutop></PublicMenutop>
      <div class="row container" role="main">
        <div class="col-md-9">
                <ul>
                    <li>Top-Uploader ever!</li>
                    <li>Top-Uploader des Monats!</li>
                </ul>
                <br>

                <div class="jumbotron" id="topuploaderever-jumbo">
                    <h1>Top-Uploader ever!</h1>

                    <p>
                        Emsig und fleißig, hilfsbereit, ganz toll. Wir freuen und bedanken uns!
                        Juheirassa. Leser helfen Ihrer Bücherei. Liebe Leser auf Land und auf See.
                        Wir sind auf dem richtigen Weg. Nicht nur daheim, auch aus der Ferne 
                        kommen die Coverbilder.
                    </p>
                </div>

                <div id="topuploaderever-details">
                <table class="table table-striped">
                <thead>
                    <tr>
                    <th scope="col">#</th>
                    <th scope="col">Bücherei</th>
                    <th scope="col">Anzahl Covers</th>
                    <th scope="col">Erster Upload jemals</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(ruhmzeile,meinindex) in ruhmeshalle" :key="meinindex">
                        <th scope="row">{{ meinindex + 1 }}</th>
                        <td>
                          <router-link :to="'/public/statistik/' + ruhmzeile.uploader"><a>{{ ruhmzeile.uploader }}</a></router-link>
                        </td>
                        <td>{{ ruhmzeile.anzahl_uploads_ever }}
                          &nbsp;
                          &nbsp;
                          &nbsp;
                          <img v-if="meinindex == 0" src="/img/findus_bullauge_49x51px.png"></td>
                        <td >{{ ruhmzeile.erster_upload_jemals_monatjahr_deutsch_kurz }}</td>
                    </tr>
                </tbody>
                </table>
                </div>

                <br>
                <br>
                <br>


                <div class="jumbotron" id="topuploaderdesmonats-jumbo">
                    <h1>Top-Uploader des Monats {{ monatstop_monatjahr_deutsch_kurz }}!</h1>
                    
                    <p>
                        Emsig und fleißig, hilfsbereit, ganz toll. Wir freuen und bedanken uns!
                        Juheirassa. Leser helfen Ihrer Bücherei. Liebe Leser auf Land und auf See.
                        Wir sind auf dem richtigen Weg. Nicht nur daheim, auch aus der Ferne 
                        kommen die Coverbilder.
                    </p>
                </div>

                <div id="topuploaderdesmonats-details">

                <table class="table table-striped">
                <thead>
                    <tr>
                    <th scope="col">#</th>
                    <th scope="col">Bücherei</th>
                    <th scope="col">Anzahl Covers diesen Monat</th>
                    <th scope="col">Erst Upload jemals </th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(monatstopzeile,meinindex) in monatstop" :key="meinindex">
                        <th scope="row">{{ meinindex + 1 }}</th>
                        <td>
                          <router-link :to="'/public/statistik/' + monatstopzeile.uploader"><a>{{ monatstopzeile.uploader }}</a></router-link>
                        </td>
                        <td>{{ monatstopzeile.anzahl_uploads }}
                          &nbsp;
                          &nbsp;
                          &nbsp;
                          <img v-if="meinindex == 0" src="/img/findus_bullauge_49x51px.png">
                        </td>
                        <td>{{ monatstopzeile.erster_upload_jemals_monatjahr_deutsch_kurz }}</td>
                    </tr>
                </tbody>
                </table>
                </div>

        </div>
        <div class="col-md-3">
          
<img src="/img/findus_auf_endlosstapel/350px_breit/endlosgrafik-findus-buchstapel-oben.png">
<img src="/img/findus_auf_endlosstapel/350px_breit/endlosgrafik-findus-buchstapel-mitte-wein.png">
<img src="/img/findus_auf_endlosstapel/350px_breit/endlosgrafik-findus-buchstapel-mitte-spinne.png">
<img src="/img/findus_auf_endlosstapel/350px_breit/endlosgrafik-findus-buchstapel-unten.png">
          


          
        </div>
      </div>
      
      <Footer></Footer>
  </div>
</template>

<script>
import PublicMenutop from '../../components/public/PublicMenutop.vue';
import Footer from '../../components/Footer.vue';
// kommt von pinegrow/bootstrap4:
import '../../components/sticky-footer-navbar.css';
import axios from 'axios';

// Mixin fuer diese Komponente importieren
import commonvars from '../mixins/commonvars.js';

export default {
  name: 'Statistik',
  components: {
    PublicMenutop,
    Footer,
  },
  data() {
    return {
      ruhmeshalle: [],
      monatstop: [],
      monatstop_monatjahr_deutsch_kurz: ""
    }
  },
  mounted: function() {
    this.hole_top_uploader();
    this.statistik_einzelseite_updaten();
  },
  mixins: [
    commonvars
  ],
  methods: {
    hole_top_uploader() {
      let statistik_url = this.api_statistik_alle_url();
      console.log("statistik wurde angefordert, url " + statistik_url);
      axios.get(statistik_url)
          .then(
              response => {
                  // console.log(response.data);
                  this.monatstop = response.data.monatstop;
                  this.ruhmeshalle = response.data.ruhmeshalle;
                  this.monatstop_monatjahr_deutsch_kurz = response.data.monatstop_monatjahr_deutsch_kurz;
              }
          );
    },
    api_statistik_alle_url() {
        return this.server_base_url() + '/api/alle/statistik';
    },
    api_statistik_einzelseite_nickname() {
      return 'ruhmeshalle';
    },
    api_statistik_einzelseite_url() {
        return this.server_base_url()
            + '/api/statistik/einzelseite/' + this.api_statistik_einzelseite_nickname();
    },
    statistik_einzelseite_updaten() {
      let url = this.api_statistik_einzelseite_url();

      axios.get(url)
      .then(
          () => {
              console.log("Update Statistik Einzelseite");
              
          }
      )
      .catch(
        () => {
            console.log("Fehler bei Update Statistik Einzelseite");
        }
      );
    }

  }
}

</script>

<style scoped>

.jumbotron {    
    background-color: #79ac2921;
}

table td {
  vertical-align: middle;
}

table th {
  vertical-align: middle;
}

a {
  text-decoration: underline;
}
</style>


